import BranchProvider from "@/modules/delivery/providers/BranchProvider";

export default {
    state: {
        branchSelected: null,
        branches: []
    },
    getters: {
        branchSelected(state) {
            return state.branchSelected
        }
    },
    actions:{
        fetchDefaultBranch({commit}) {
            return new Promise((resolve, reject) => {
                BranchProvider.findBranchDefault()
                    .then(r => {
                        commit("branchSelected", r.data.findBranchDefault)
                        resolve(r.data.findBranchDefault)
                    })
                    .catch(e => {
                        reject(e)
                    })
            })
        },
    },
    mutations: {
        branchSelected(state, branch) {
            state.branchSelected = branch
        }
    }
}
